module.exports = __webpack_public_path__ + "static/img/dash-2.272dace3.png";